<template>
  <div class="basket-form-delivery-types text-center" id="basket-form-delivery-types">
    <h4>Оплата заказа</h4>

    <div v-if="paymentSystems && paymentSystems.length" class="mt-2 d-flex justify-center">
      <v-radio-group v-model="form.paymentSystemId" :row="isSM" @change="onSelect">
        <template v-for="(item, index) of paymentSystems">
          <v-radio :key="'payment-system-'+index"
                   :value="item.id"
                   :class="'destination'+destinationCity">
            <template v-slot:label>
              <div class="d-md-none">
                <div>{{ item.label }}</div>
                <div class="size2 color-gray" v-html="item.hint"></div>
              </div>
              <span class="d-none d-md-block" :title="item.hint ? item.hint.replace(/(<([^>]+)>)/ig, '') : ''">{{ item.label }}</span>
            </template>
          </v-radio>
          <div v-if="item.separator" class="separator d-none d-md-block">&nbsp;</div>
        </template>
      </v-radio-group>
    </div>
    <div v-else class="mt-2 d-flex justify-center">
      {{ defaultPaymentSystem.label }}
    </div>

    <div v-if="isSelfPaymentSystemChoosed && cashOnPickupText" v-html="cashOnPickupText" class="size1"></div>
  </div>
</template>

<script>
import vp from '@/mixins/vp';
import {objectToArray} from '@/utils/utils';
import {
  PAYMENT_SYSTEM_ID_SELF,
  PAYMENT_SYSTEM_ID_DEFERRED,
  paymentSystems,
  PAYMENT_SYSTEM_ID_LINK, PAYMENT_SYSTEM_ID_LEGAL_ENTITY
} from '@/store/payment';
import {
  DELIVERY_TYPE_SELF,
  deliveryTypes,
  DESTINATION_MSK,
  DESTINATION_RUSSIA,
  DESTINATION_SPB
} from '@/store/delivery';
import {destinations} from "../../store/delivery";
import metrika from "@/utils/metrika";

let isPaymentMethodChosen = false;

export default {
  name: "basket-form-delivery-types",
  props: {
    form: {},
    isCakeInBasket: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [vp],
  emits: ["select", "paymentSystemError"],
  data() {
    return {}
  },
  watch: {
    /*"form.deliveryTypeId": {
      immediate: true,
      handler(deliveryTypeId) {
        if (this.paymentSystems?.length === 1 && this.form.destinationId !== DESTINATION_RUSSIA) this.form.paymentSystemId = this.paymentSystems[0].id;
        else if (this.paymentSystems?.length > 1) this.form.paymentSystemId = null;
        else this.form.paymentSystemId = PAYMENT_SYSTEM_ID_DEFERRED;

        //console.log("PAYMENT SYSTEM SET: "+this.form.paymentSystemId);
      }
    }*/
  },
  computed: {
    withPayment() {
      return this.form.deliveryTypeId !== null || (this.form.destinationId === DESTINATION_RUSSIA && this.paymentSystems.length);
    },
    payments() {
      return this.$store.state.page.BasketController?.payments;
    },
    defaultPaymentSystem() {
      return paymentSystems.find(el => el.id === PAYMENT_SYSTEM_ID_DEFERRED);
    },
    deliveryType() {
      return deliveryTypes.find(el => el.id === this.form.deliveryTypeId);
    },
    paymentSystems() {
      let ps = [...paymentSystems];

      ps = ps.filter(el => this.payments?.some(payment => Number(payment.ID) === el.id));

      return ps;

      /**
       * По задаче отображаем все способы оплаты.
       * В зависимости от выбранного способа оплаты отображаем только доступные способы доставки.
       */

      /*if (this.form.destinationId === DESTINATION_RUSSIA) {
        // Если выбран пункт назначения Другой город, то отображаем только оплату для юр. лиц
        ps = ps.filter(el => el.id === PAYMENT_SYSTEM_ID_LEGAL_ENTITY)
            .filter(el => this.payments?.some(payment => Number(payment.ID) === el.id));

        if (this.isCakeInBasket) {
          // но если в корзине есть торт, то оплата для юр. лиц недоступна
          ps = ps.filter(el => el.id !== PAYMENT_SYSTEM_ID_LEGAL_ENTITY);
        }

        return ps;
      }

      ps = ps.filter(el => this.deliveryType?.paymentSystemIds?.some(id => id === el.id))
             .filter(el => this.payments?.some(payment => Number(payment.ID) === el.id));

      if (this.form.deliveryTypeId === DELIVERY_TYPE_SELF) {
        // если выбран самовывоз
        if (this.form.destinationId === DESTINATION_SPB) {
          // если выбран город Санкт-Петербург, проверяем доступность оплаты по ссылке
          if (objectToArray(this.$store.state.page.BasketController?.settings)?.find(el => el.CODE === 'IS_PAYMENT_SYSTEM_LINK_AVAILABLE_SPB')) {
            ps = ps.filter(el => el.id === PAYMENT_SYSTEM_ID_LINK || el.id === PAYMENT_SYSTEM_ID_LEGAL_ENTITY);
          } else {
            ps = ps.filter(el => el.id === PAYMENT_SYSTEM_ID_SELF || el.id === PAYMENT_SYSTEM_ID_LEGAL_ENTITY);
          }
        } else if (this.form.destinationId === DESTINATION_MSK) {
          // если выбран город Москва, проверяем доступность оплаты по ссылке
          if (objectToArray(this.$store.state.page.BasketController?.settings)?.find(el => el.CODE === 'IS_PAYMENT_SYSTEM_LINK_AVAILABLE_MSK')) {
            ps = ps.filter(el => el.id === PAYMENT_SYSTEM_ID_LINK || el.id === PAYMENT_SYSTEM_ID_LEGAL_ENTITY);
          } else {
            ps = ps.filter(el => el.id === PAYMENT_SYSTEM_ID_SELF || el.id === PAYMENT_SYSTEM_ID_LEGAL_ENTITY);
          }
        }
      }

      if (this.isCakeInBasket) {
        // если в корзине есть торт, то оплата для юр. лиц недоступна
        ps = ps.filter(el => el.id !== PAYMENT_SYSTEM_ID_LEGAL_ENTITY);
      }

      return ps;*/
    },
    destinationCity() {
      return destinations.id;
    },
    isSelfPaymentSystemChoosed() {
      return this.form.paymentSystemId === PAYMENT_SYSTEM_ID_SELF;
    },
    cashOnPickupText() {
      return this.$store.state.page.BasketController?.settings?.CASH_ON_PICKUP_TEXT?.DETAIL_TEXT.trim();
    }
  },
  methods: {
    async onSelect(paymentSystemId) {
      /*setTimeout(() => {
        scrollTo("basket-form-payment", -120);
      }, 300);*/

      if (!isPaymentMethodChosen) {
        metrika.reachGoal('choicePaymentMethodBasket');
        isPaymentMethodChosen = true;
      }

      this.form.destinationId = null;
      this.form.deliveryTypeId = null;
      this.form.deliveryZoneId = null;
      this.form.CITY = null;
      this.form.STREET = null;

      this.$emit("select");
    },
  },
}
</script>

<style lang="scss">
.basket-form-delivery-types {
  .separator {
    flex-basis: 100%;
    width: 0;
    height: 0;
  }

  .v-input--radio-group__input {
    justify-content: center;
    gap: 10px 0;
  }

  .v-radio {
    align-items: flex-start;

    .v-label {
      margin-top: 2px;
    }
  }
}
</style>